import {ISegmentationTargetDTO, SegmentationTarget} from "@/modules/Segmentation/models/SegmentationTarget";
import {ISegmentationTargetService} from "@/modules/Segmentation/services/ISegmentationTargetService";
import {inject, injectable} from "tsyringe";
import {IHttpService, NullPointerException} from "frontend-core";
import {SegmentationTargetDTO} from "@/modules/Segmentation/models/SegmentationTargetDTO";
import {Agent} from "@/models/Agent";
// @ts-ignore
import getHashCode from "object-hash";

@injectable()
export class SegmentationTargetService implements ISegmentationTargetService {
    constructor(
        @inject("IHttpService")
        private readonly httpService: IHttpService,
    ) {
    }

    async get(id: string): Promise<SegmentationTarget | null> {
        let res: SegmentationTarget | null = null;

        await this.httpService.api.get<ISegmentationTargetDTO>(
            `/agent_segmentations/${id.replace("/api/agent_segmentations/", "")}`
        )
            .then((data) => {
                res = new SegmentationTarget(data.data);
            })
            .catch(() => {
                res = null
            });

        return res;
    }

    async getByAgentId(agentId: string): Promise<SegmentationTarget | null> {
        let res: SegmentationTarget | null = null;

        await this.httpService.api.get<ISegmentationTargetDTO>(
            `/agents/${agentId.replace("/api/agent_segmentations/", "")}/segments`
        )
            .then((data) => {
                res = new SegmentationTarget(data.data);
            })
            .catch(() => {
                res = null
            });

        return res;
    }

    async update(obj: SegmentationTarget): Promise<void> {
        const dto: SegmentationTargetDTO = new SegmentationTargetDTO(obj);

        await this.httpService.api.put("/agent_segmentations/" + obj.id, dto.serialize());
    }

    async lock(target: SegmentationTarget, agent: Agent): Promise<SegmentationTarget> {
        const parentTarget: SegmentationTarget | null = await this.getByAgentId(
            agent.parentId.replace("/api/agents/", "")
        );

        if (!parentTarget) {
            throw new NullPointerException();
        }

        const newTarget: SegmentationTarget = new SegmentationTarget(
            [],
            [],
            target.id,
            target.agentId,
            "/api/agent_segmentations/" + parentTarget.id
        );

        await this.update(newTarget);

        const finalTarget: SegmentationTarget | null = await this.getByAgentId(agent.id);

        if (!finalTarget) {
            throw new NullPointerException();
        }

        return finalTarget;
    }

    async unLock(target: SegmentationTarget): Promise<SegmentationTarget> {
        const newTarget: SegmentationTarget = new SegmentationTarget(
            target.segments.filter(i => !i.isMasterRule.boolean),
            target.antiSegments.filter(i => !i.isMasterRule.boolean),
            target.id,
            target.agentId,
            null
        );

        await this.update(newTarget);

        return newTarget;
    }

    getHashCode(target: SegmentationTarget): string {
        return getHashCode(target);
    }

    async setInheritedSegmentation(agentId: string) {
        await this.httpService.api.post(`/agents/${agentId}/set_inherited_segmentation`, {});
    }
}
